import React from "react";
import Icon from "./icon";

function NoIcon(props) {
  return <Icon viewBox="0 0 512 512" {...props}></Icon>;
}
export default NoIcon;
